import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export const Slide01Hero = () => {
  return <div className="relative w-full h-full flex flex-col justify-center px-24 bg-slate-950 overflow-hidden" data-id="element-21">
      {/* Cinematic Background */}
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2940&auto=format&fit=crop')] bg-cover bg-center opacity-20 mix-blend-luminosity" data-id="element-22" />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/90 to-transparent" data-id="element-23" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" data-id="element-24" />

      {/* Subtle Red Brand Glow */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-red-800/20 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-25" />

      <div className="relative z-10 max-w-5xl" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2,
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-27">
          <div className="flex items-center space-x-3 mb-8" data-id="element-28">
            <div className="h-[1px] w-12 bg-red-600" data-id="element-29" />
            <span className="text-red-500 font-semibold tracking-widest uppercase text-sm" data-id="element-30">
              Internal Engagement Strategy
            </span>
          </div>

          <h1 className="text-7xl font-bold tracking-tight mb-8 leading-[1.1] text-white" data-id="element-31">
            Don’t Broadcast Morale.
            <br data-id="element-32" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700" data-id="element-33">
              Build It.
            </span>
          </h1>

          <p className="text-2xl text-slate-300 font-light leading-relaxed max-w-3xl border-l-2 border-red-600/50 pl-6 mb-10" data-id="element-34">
            When organizations face pressure, communication alone isn’t enough.{' '}
            <br data-id="element-35" />
            <span className="text-white font-medium" data-id="element-36">
              Participation creates momentum.
            </span>
          </p>

          <div className="flex items-center space-x-5" data-id="element-37">
            <span className="text-xs uppercase tracking-[0.3em] text-slate-500" data-id="element-38">
              Framework
            </span>
            <div className="flex items-center space-x-4" data-id="element-39">
              {['Attract', 'Retain', 'Mobilize'].map((word, i) => <Fragment key={word} data-id="element-40">
                  <span className="text-base font-semibold text-white tracking-wide" data-id="element-41">
                    {word}.
                  </span>
                  {i < 2 && <span className="w-1 h-1 rounded-full bg-red-500" data-id="element-42" />}
                </Fragment>)}
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
};